<template>
  <CModalHeader>
    <CModalTitle>{{ $t(titleKey) }}</CModalTitle>
  </CModalHeader>
  <CModalBody>
    {{ $t(descriptionKey) }}
  </CModalBody>
  <CModalFooter>
    <CButton color="danger" :disabled="isPending" @click="close(false)">{{ $t('message.cancel') }}</CButton>
    <CButton :color="confirmButtonColor" :disabled="isPending" @click="onConfirm">
      <CSpinner v-if="isPending" component="span" size="sm" class="me-2" aria-hidden="true" />
      {{ $t('message.confirm') }}
    </CButton>
  </CModalFooter>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import { AppService } from '@/services/app.service'
import { UserService } from '@/services/user.service'
import TokenService from '@/services/storage.service'

const props = defineProps({
  mode: {
    type: String,
    default: 'enable',
    validator: (value) => ['enable', 'disable'].includes(value),
  },
})

const store = useStore()
const emit = defineEmits(['close'])

const isPending = ref(false)

const isDisableMode = computed(() => props.mode === 'disable')

const titleKey = computed(() =>
  isDisableMode.value ? 'message.maintenance_mode_disable_title' : 'message.maintenance_mode_title'
)

const descriptionKey = computed(() =>
  isDisableMode.value ? 'message.maintenance_mode_disable_description' : 'message.maintenance_mode_description'
)

const confirmButtonColor = computed(() => (isDisableMode.value ? 'danger' : 'primary'))

const enableMaintenance = async () => {
  await AppService.createMaintenance()
  await store.dispatch('adminMe')
  store.commit('SET_IS_MAINTANANCE', true)
}

const disableMaintenance = async () => {
  await AppService.deleteMaintenance()
  TokenService.removeAdminData()

  const response = await UserService.me()
  TokenService.saveAdminData(JSON.stringify(response.data.data))
  store.commit('SET_USER', response.data.data)
  store.commit('SET_ADMIN_ROLE', response.data.data.roles)
  store.commit('SET_IS_MAINTANANCE', false)
}

const onConfirm = async () => {
  isPending.value = true

  try {
    if (isDisableMode.value) {
      await disableMaintenance()
    } else {
      await enableMaintenance()
    }

    isPending.value = false
    emit('close', true)
  } catch (error) {
    isPending.value = false
    throw error
  }
}

const close = (value) => {
  if (isPending.value) {
    return
  }

  emit('close', value)
}
</script>
